// src/services/UserService.js
import fetch from 'auth/FetchInterceptor';

const UserService = {};

UserService.getAll = function (params = {}) {
    return fetch({
        url: '/v1/users',
        method: 'get',
        params,
    });
};

UserService.getById = function (id) {
    return fetch({
        url: `/v1/users/${id}`,
        method: 'get',
    });
};

UserService.create = function (data) {
    return fetch({
        url: '/v1/users',
        method: 'post',
        data,
    });
};

UserService.update = function (id, data) {
    return fetch({
        url: `/v1/users/${id}`,
        method: 'put',
        data,
    });
};

UserService.remove = function (id) {
    return fetch({
        url: `/v1/users/${id}`,
        method: 'delete',
    });
};

export default UserService;